import { render, staticRenderFns } from "./VideosPlaylistItem.vue?vue&type=template&id=13a4834a&scoped=true"
import script from "./VideosPlaylistItem.vue?vue&type=script&lang=js"
export * from "./VideosPlaylistItem.vue?vue&type=script&lang=js"
import style0 from "./VideosPlaylistItem.vue?vue&type=style&index=0&id=13a4834a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a4834a",
  null
  
)

export default component.exports